export class GetMachineReportsHistory {
  static readonly type = '[MachineReports] Get Machine Reports History';

  constructor(
    public geaPUID: string,
    public page: number,
    public pageSize?: number
  ) {}
}

export class ToggleSubscriptionReport {
  static readonly type = '[MachineReports] Toggle Subscription Report';

  constructor(
    public geaPUID: string,
    public timezone: string,
    public toggleSubscribeEnabled: boolean
  ) {}
}

export class GetMachineAutomaticSubscriptionEnabled {
  static readonly type = '[MachineReports] Get Machine Automatic Subscription Enabled';

  constructor(public geaPUID: string) {}
}
